import React, { useEffect, useState } from 'react';
import Loading from '../../components/loading/Loading';
import { useParams } from 'react-router-dom';
import { BackendPayload, FormsProps, FormType } from '../../types/forms';
import { getDecisionCriteria } from '../../api/decisions.api';
import { transformFormFields } from '../../utils/forms.utils';
import ViewTableForm from '../../components/forms/ViewTableForm';
import ViewSingleRowForm from '../../components/forms/ViewSingleRowForm';
import DataEntryForm from '../../components/forms/DataEntryForm';
import ViewAndEditTableForm from '../../components/forms/ViewAndEditTableForm';

const components = {
    view_table: ViewTableForm,
    view_row_navigation: ViewSingleRowForm,
    data_entry_table: DataEntryForm,
    data_entry_row: DataEntryForm,
    add_row: DataEntryForm,
    edit_table: ViewAndEditTableForm,
    branching_form: DataEntryForm,
};

const Forms = () => {
    const [ loading, setLoading ] = useState(true);
    const [ formType, setFormType ] = useState<FormType>();
    const [ skin, setSkin ] = useState<'skin1' | 'skin2'>('skin1');
    const [ linkedFormId, setLinkedFormId ] = useState<number>();
    const [ formAllFields, setFormAllFields ] = React.useState<BackendPayload['fields']>([]);
    const { formId } = useParams();

    useEffect(() => {
        if (!formId) {
            setLoading(false);
            return;
        }

        getDecisionCriteria(formId)
        .then(response => {
            const { form_type, skin, link_decision_id } = response.config;
            setFormType(form_type);
            setSkin(skin);
            setLinkedFormId(link_decision_id);
            const elements: any[] = response.form_config.elements;
            const formattedElements: BackendPayload['fields'] = [];
            elements.forEach(element => {
                formattedElements.push(...transformFormFields(element.children));
            });
            setFormAllFields(formattedElements);
        })
        .finally(() => setLoading(false));
    }, [ formId ]);

    if (!formId || !formType) {
        return <Loading/>;
    }

    const CurrentComponent = components[formType];
    const props: FormsProps = {
        formId,
        linkedFormId,
        skin,
        formAllFields,
        formType,
    };

    return (
        <div>
            {loading ? <Loading/> : (
                <div style={{ width: '95%', margin: '32px auto' }}>
                    <CurrentComponent {...props} />
                </div>
            )}
        </div>
    );
};

export default Forms;
